export default "/fonts/TiemposHeadline-Medium.svg?59a38384b25084fac1a730c8855455e4";